import en from './checkout.en';

const enConfig = { en };

export default enConfig;
